<script>
    import { push } from 'svelte-spa-router'
	import { fade } from 'svelte/transition';
	import Header from './Header.svelte';

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    // The params prop contains values matched from the URL
    export let params = {}

    let dash_token = params.t
	let mebot_id = params.id
    let var_type_id = params.type_id

    if (dash_token != '1') {
		if (getCookie("m_dash_token") != '') {
			dash_token = getCookie("m_dash_token")
		}
		if (dash_token == '' || dash_token == null) {
			dash_token = '1';
		}
	}

    let result = null
    let mebot_img_url = null;
    let watts_score = '';
    let steps = '';
    let explorer = '';
    let social = '';
    let hrv = '';
    let sleep = '';
    let m1 = null;
    let m2 = null;
    let mebots = [];

    function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function set_section(name) {
        setCookie("section", name, 1)
    }

	set_section('leaderboard');
	
	async function fetchLeaderboard(type_id = 1) {

        var_type_id = type_id
        const res = await fetch('https://api.forever.today/?method=get_move_leaderboard', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                type_id
            })
		})

        const json = await res.json()
        result = json
        //json.data.mebots.forEach((x, i) => console.log(x));
        mebots = json.data.mebots.slice(0, 9);
    }

    fetchLeaderboard(var_type_id)

</script>

<Header
	header_mebot_id = { mebot_id }
	header_dash_token = { dash_token }
/>

<menu>
    <center>
        <div class="menu_row">
            <table width=300px><tr>
                <td width=100px align=left>
                    <button class="menu_btn_home" class:menu_active={ var_type_id == 1 } on:click={() => fetchLeaderboard("1")}>
                        <span class="leaderboard" >
                            &nbsp; <span class="text-electric">🏆 &nbsp; Day </span> &nbsp;
                        </span>
                    </button>
                </td>
                <td width=100px align=left>
                    <button class="menu_btn_home" class:menu_active={ var_type_id == 2 } on:click={() => fetchLeaderboard("2")}>
                        <span class="leaderboard" >
                            &nbsp; <span class="text-electric">🏆 &nbsp; Week </span> &nbsp;
                        </span>
                    </button>
                </td>
                <td width=100px align=left>
                    <button class="menu_btn_home" class:menu_active={ var_type_id == 3 } on:click={() => fetchLeaderboard("3")}>
                        <span class="leaderboard" >
                            &nbsp; <span class="text-electric">🏆 &nbsp; All Time </span> &nbsp;
                        </span>
                    </button>
                </td>
            </tr></table>
        </div>
    </center>
</menu>

<center>
    <div class="snake_row">
        {#each mebots as mebot, i}
            <div class="flip-box" class:mebot_large={i < 3} class:mebot_small={i >= 3} >
                <div class="flip-box-inner">
                    <div class="flip-box-front card">
                        <div class="vertical-center" style="white-space: nowrap;">
							<div class="message question" data-card-id={i} transition:fade|local={{duration: 300}}>
                                <a href="/#/stats/{dash_token}/{mebot_id}/{mebot.id}">
                                <img src="{mebot.mebot_img_url}" width={i >= 3 ? '80px' : '100px'} class:mebot_active1={ mebot.id == mebot_id } alt="mebot"></a><br>
                                <span style="display: flex; align-items:center;" >
                                    {#if (i < 3) }
                                    {@html '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' }
                                    {:else }
                                    {@html '&nbsp;&nbsp;&nbsp;' }
                                    {/if}
                                <span class="text-electric" style="color:silver; margin-top: 4px;" ><span class="text-electric-yellow" style="font-size:0;"><img src='/img/sparkle-zm1.png' width=20px; alt=''></span></span>
                                <span  class="text-electric-white" class:mebot_owner={ mebot.id == mebot_id }> { mebot.sparkles_n } </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>

	<div class="small_row">
	</div>

</center>

<style>

.menu_row {
    display: flex;
    flex-wrap: wrap;
    width: 300px;
    justify-content: right;
    margin-bottom: 20px;
    margin-right: 30px;
}

	.question {
		color: white;
		font-size: 18px;
		text-shadow: 0 0 40px rgba(195, 195, 195, 0.9), 0 0 32px rgba(255, 255, 255, 0.98);
		font-family: arial;
	}

	.snake_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		justify-content: center;
		margin-bottom: 0px;
	}
	.small_row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		margin-bottom:  0px;
		margin-left: 44px;
		margin-right: 36px;
	}

    .text-electric-white {
		text-shadow: 0 0 2px rgba(253, 253, 253, 0.9),
			0 0 0px rgba(252, 252, 252, 0.98);
		font-family: arial;
		color: hsl(60, 19%, 88%);
        font-size: 12px;
	}

	/* The flip box container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
	.flip-box {
		background-color: transparent;
		border: 0px solid #f1f1f1;
		/* perspective: 1000px; Remove this if you don't want the 3D effect */
	}

    .mebot_large {
        width: 100px;
        height: 100px; 
        margin: 0 6px 60px;
    }

    .mebot_small {
        width: 80px;
        height: 80px; 
        margin: 0 10px 50px;
    }

    .mebot_owner {
        font-weight: bold;
        color: rgba(65, 255, 249, 0.98);
        text-shadow: 0 0 5px rgba(253, 253, 253, 0.9),
			0 0 8px rgba(252, 252, 252, 0.98);
		font-family: arial;
        font-size: 12px;
    }

    .mebot_active {
        border-radius: 15px;
        background-color: #42e3ffe5;
        box-shadow: 0 3px 7px rgb(231, 247, 255);
    }

    .mebot_active1 {
        border-radius: 15px;
        box-shadow: 0 3px 7px rgb(231, 247, 255);

        background: linear-gradient(114deg, #ffffff, #725cd8, #42e3ff, #42e3ff);
    background-size: 800% 800%;

    -webkit-animation: AnimationName 6s ease infinite;
    -moz-animation: AnimationName 6s ease infinite;
    -o-animation: AnimationName 6s ease infinite;
    animation: AnimationName 6s ease infinite;
}

@-webkit-keyframes AnimationName {
    0%{background-position:0% 71%}
    50%{background-position:100% 30%}
    100%{background-position:0% 71%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 71%}
    50%{background-position:100% 30%}
    100%{background-position:0% 71%}
}
@-o-keyframes AnimationName {
    0%{background-position:0% 71%}
    50%{background-position:100% 30%}
    100%{background-position:0% 71%}
}
@keyframes AnimationName {
    0%{background-position:0% 71%}
    50%{background-position:100% 30%}
    100%{background-position:0% 71%}
}

	/* This container is needed to position the front and back side */
	.flip-box-inner {
		position: relative;
		width: 100%;
		height: 100%;
		text-align: center;
		transition: transform 0.8s;
		transform-style: preserve-3d;
	}

	/* Position the front and back side */
	.flip-box-front, .flip-box-back {
		position: absolute;
		width: 100%;
		height: 100%;
		-webkit-backface-visibility: hidden; /* Safari */
		backface-visibility: hidden;
	}

    .vertical-center {
    }

    .message {
    }

	img {
	}

	.card {
	}

    .menu_btn_home {
		border-radius: 5px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #202020;
		color: rgba(255, 255, 255, 1);
		padding: 3px 4px 6px 4px;
		box-shadow: 0 5px 15px rgba(145, 145, 145, .4);
	}
	.leaderboard {
        white-space: nowrap;
		font-size: 12px;
	}

    .menu_active {
        background-color: #202020;
        box-shadow: 0 3px 7px rgb(231, 247, 255);
    }
</style>